// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__k7xo1","water":"Tags_water__oUwIK","rotate":"Tags_rotate__N_3Pv","pulsate":"Tags_pulsate__GjoLH"};